import { useState, useEffect } from "react";
import {
  getFinanceOverview,
  FinanceOverview,
  getFinanceDashboard,
  FinanceDashboard,
} from "../../../services/financeService";

export const useFinanceStats = () => {
  const [overview, setOverview] = useState<FinanceOverview | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [dashboard, setDashboard] = useState<FinanceDashboard | null>(null);

  const fetchFinanceOverview = async () => {
    try {
      setLoading(true);
      const data = await getFinanceOverview();
      setOverview(data.data);
      setError(null);
    } catch (err) {
      setError("Failed to fetch finance statistics");
      console.error("Error fetching finance stats:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchFinanceDashboard = async (filters: any) => {
    try {
      setLoading(true);
      const data = await getFinanceDashboard(filters);
      console.log(data);
      setDashboard(data.data);
      setError(null);
    } catch (err) {
      setError("Failed to fetch finance statistics");
      console.error("Error fetching finance stats:", err);
    } finally {
      setLoading(false);
    }
  };

  return { overview, loading, error, fetchFinanceOverview, fetchFinanceDashboard, dashboard };
};

export default useFinanceStats;
